<div class="field-container">
  <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
  <p-password #Password [(ngModel)]="value" size="small" autocomplete="off" appendTo="{{appendTo}}" [toggleMask]="true"
    [feedback]="feedback" promptLabel="Ingrese una contraseña" weakLabel="Débil" mediumLabel="Media"
    strongLabel="Fuerte" [disabled]="disabled" [ngClass]="[inputClass]" (input)="changeText($event)"
    (focus)="selectAllText($event)" (blur)="changeTextOnBlur($event)">
    <ng-template *ngIf="visibleDescription" #footer>
      <p-divider />
      <ul class="pl-2 my-0 leading-normal">
        <li>Al menos una minúscula</li>
        <li>Al menos una mayúscula</li>
        <li>Al menos un número</li>
        <li>Al menos un caracter especial</li>
        <li>Mínimo 8 caracteres</li>
      </ul>
    </ng-template>
  </p-password>
</div>